/**
 * Ouvre / télécharge un Blob de manière fiable cross-browser.
 *
 * Stratégie :
 * 1. Pour les PDF/images visuelles → ouvre dans un NOUVEL ONGLET (le navigateur
 *    affiche le PDF nativement, l'utilisateur peut imprimer ou enregistrer).
 *    C'est la seule méthode fiable dans les iframes (preview Emergent, etc.)
 *    où Firefox bloque les downloads forcés.
 * 2. Pour les CSV/JSON (non visualisables) → tente le download forcé,
 *    avec fallback ouverture nouvel onglet si bloqué.
 *
 * Le suggestedFilename est ajouté à l'URL pour que "Enregistrer sous…"
 * propose un nom correct dans le navigateur.
 */
export function downloadBlob(blob, filename) {
  const isPdf = blob.type === "application/pdf" || /\.pdf$/i.test(filename);
  const isImage = blob.type.startsWith("image/");

  // Pour les PDF/images : ouvrir dans nouvel onglet (Firefox-friendly dans iframes)
  if (isPdf || isImage) {
    return openInNewTab(blob, filename);
  }

  // Pour CSV/JSON/autres : tentative de téléchargement classique
  return forceDownload(blob, filename);
}

function openInNewTab(blob, filename) {
  const url = URL.createObjectURL(blob);
  // window.open() doit être appelé dans le contexte direct du clic utilisateur
  const win = window.open(url, "_blank", "noopener,noreferrer");
  if (!win) {
    // Popup bloqué → fallback sur le téléchargement forcé classique
    forceDownload(blob, filename);
    return;
  }
  // Pour aider le navigateur à proposer un nom de fichier correct
  try { win.document.title = filename; } catch { /* cross-origin, ignoré */ }
  // Libère l'URL après que le nouvel onglet l'ait chargée
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

function forceDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    if (a.parentNode) a.parentNode.removeChild(a);
    URL.revokeObjectURL(url);
  }, 2000);
}
